import {
  Box,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Textarea,
  VStack,
} from "@chakra-ui/react";
import PropTypes from "prop-types";
import React, { useRef } from "react";
import ModelFooterButtons from "./modelFooterButtons";
import ModelsTriggerButton from "./modelsTriggerButton";
import * as Yup from "yup";
import { Field, Formik } from "formik";

const AddDeviceTypeModal = ({ isOpen, onClose, setIsModalOpen, onSave }) => {
  const initialRef = useRef(null);
  const finalRef = useRef(null);

  // useEffect(() => {
  //   // TODO: check if the name is existing
  // }, [device_type_name]);

  const nameRegex = /^[a-zA-Z0-9\s]+$/;
  const formValidationSchema = Yup.object().shape({
    type: Yup.string()
      .matches(nameRegex, "Type must contain only letters, numbers and spaces")
      .max(45, "Type must be at most 45 characters.")
      .required("Type is required"),
    notes: Yup.string().max(300, "Notes must be at most 300 characters."),
  });

  const styles = {
    formItem: {
      mt: 4,
    },
    input: {
      size: "sm",
      borderRadius: 6,
    },
  };

  return (
    <>
      <ModelsTriggerButton setIsModalOpen={setIsModalOpen} type="Product" />
      <Modal
        blockScrollOnMount={false}
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add New Product</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={2}>
            <Formik
              initialValues={{
                type: "",
                notes: "",
              }}
              validationSchema={formValidationSchema}
              onSubmit={(values) => {
                const payload = {
                  note: values?.notes,
                  type: values?.type,
                };
                onSave(payload);
              }}
            >
              {({ handleSubmit, errors, touched }) => (
                <form onSubmit={handleSubmit}>
                  <VStack {...styles.formStack}>
                    <FormControl isInvalid={errors?.type && touched?.type}>
                      <FormLabel htmlFor="type">Product</FormLabel>
                      <Field
                        as={Input}
                        {...styles.input}
                        id="type"
                        name="type"
                        type="text"
                        placeholder="Product Name"
                      />
                      <FormErrorMessage>{errors?.type}</FormErrorMessage>
                    </FormControl>
                    <FormControl isInvalid={errors?.notes && touched?.notes}>
                      <FormLabel htmlFor="notes">Notes</FormLabel>
                      <Field
                        as={Textarea}
                        {...styles.input}
                        id="notes"
                        name="notes"
                        type="textarea"
                        placeholder="Notes for this type"
                      />

                      <FormErrorMessage>{errors?.notes}</FormErrorMessage>
                    </FormControl>

                    <Box justifyContent={"flex-end"} width={"100%"}>
                      <ModelFooterButtons
                        onClose={onClose}
                        onSave={handleSubmit}
                      />
                    </Box>
                  </VStack>
                </form>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

AddDeviceTypeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  setIsModalOpen: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};
export default AddDeviceTypeModal;
